import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AbstractSubscriptionContentsComponent, SubscriptionContentContextModel } from '@app/@shared/components/abstract/abstract-subscription-contents/abstract-subscription-contents.component';
import { Video } from '@app/@shared/models/market-analysis/market-analysis';
import { NavigationModules, isChannel } from '@app/@shared/models/navigation/navigation.models';
import {AnalysisFilter} from '@app/@shared/models/reverse-engineering/analysis.models';
import { EntitlementService } from '@app/@shared/services/entitlement/entitlement.service';
import { NavigationService } from '@app/@shared/services/navigation/navigation.service';
import { SearchService } from '@app/@shared/services/search/search.service';
import { TelemetryService } from '@app/@shared/services/telemetry-service';
import { FilterHelper } from '@app/@shared/utils/filter-helper';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';
import {catchError, concatMap, filter, map} from 'rxjs/operators';

@Component({
    selector: 'app-subscription-videos-page',
    templateUrl: './subscription-videos-page.component.html',
    styleUrls: ['./subscription-videos-page.component.scss'],
    standalone: false
})
@UntilDestroy()
export class SubscriptionVideosPageComponent extends AbstractSubscriptionContentsComponent implements OnInit {
  videos: Array<Video>;
  videoCount: number;
  module: NavigationModules = this.route.snapshot.data.module;

  get subscriptionId(): string {
    return this.subscriptionIds[0];
  }

  constructor(
    protected route: ActivatedRoute,
    protected searchService: SearchService,
    protected navigationService: NavigationService,
    protected entitlementService: EntitlementService,
    protected router: Router,
    protected telemetryService: TelemetryService,
  ) {
    super(
      route,
      router,
      navigationService,
      telemetryService
    );
  }

  protected getContext(): Observable<SubscriptionContentContextModel> {
    return this.route.parent.paramMap.pipe(
      filter((params) => params.has('subscriptionId')),
      concatMap((params) => this.navigationService.getSubscription(params.get('subscriptionId'), this.module)),
      map((subscription) => ({
        subscriptionIds: [subscription.id],
        channelIds: subscription.children.filter(isChannel).map((channel) => channel.id),
        searchContext: subscription.name,
        tagFilters: subscription.tagsGrouped?.filters,
      })),
    );
  }

  protected requestContent(queryParams: ParamMap): Observable<AnalysisFilter[]> {
    if (this.channelIds.length === 0) {
      this.resetVideos();
      return of([]);
    }
    const filters = {
      ...FilterHelper.parseFiltersFromParams(queryParams),
      ...this.tagFilters,
    }

    return this.searchService.getVideos(
      this.searchTerm,
      filters,
      this.paginationOptions
    ).pipe(
      map((result) => {
        this.videos = result.videos;
        this.videoCount = result.count;
        return result.filters ?? [];
      }),
      catchError(() => {
        this.resetVideos();
        return of([]);
      })
    );
  }

  private resetVideos(): void {
    this.videos = [];
    this.videoCount = 0;
  }
}
